export const calculateWorkerPoint = (totalPoint, totalRate) => {
  if (totalRate === 0) {
    return '-';
  }
  totalPoint = (100 * totalPoint) / 5;

  return `%${Math.round(totalPoint / totalRate)}`;
};
